import { render } from "./detail-overview.vue?vue&type=template&id=d58b45ba"
import script from "./detail-overview.vue?vue&type=script&lang=js"
export * from "./detail-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__